import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import H3 from '../Headings/H3Element';
import { useTranslation } from 'react-i18next';

const Breadcrumbs = (props) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Container fluid={true}>
        <div className='page-title'>
          <Row>
            <Col xs='6'>
              <H3>{t(props.mainTitle)}</H3>
            </Col>
            {/* <Col xs='6'>
              <ol className='breadcrumb'>
                <li className='breadcrumb-item'>
                  <Link to={`${userData.role === 'admin' ? '/dashboard' : '/app/home'}`}>
                    <SvgIcon iconId='stroke-home' />
                  </Link>
                </li>
                <li className='breadcrumb-item'>{t(props.parent)}</li>
                {props.subParent ? <li className='breadcrumb-item'>{t(props.subParent)}</li> : ''}
                <li className='breadcrumb-item active'>{t(props.title)}</li>
              </ol>
            </Col> */}
            <Col xs='12' md='8'>
              <div className='d-flex justify-content-md-end align-items-center'>
                {props.buttons && props.buttons.map((button, index) => (
                  <div key={index} className='me-md-2' style={{ whiteSpace: 'nowrap' }}>
                    {button}
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default Breadcrumbs;